/**
 * Staff payment methods on the voucher Pay Invoice modal.
 * Keep in sync with gymXs_backend/services/voucherPaymentMethodAccess.js.
 */

import { isPlatformSuperAdmin } from "./roleAccess";

export const VOUCHER_PAYMENT_METHODS = [
  { value: "Cash", permission: "subscriptions:pay_cash", label: "Cash" },
  { value: "Card", permission: "subscriptions:pay_card", label: "Card" },
  { value: "Online", permission: "subscriptions:pay_online", label: "Online" },
  { value: "Jazzcash", permission: "subscriptions:pay_jazzcash", label: "JazzCash" },
  { value: "Cheque", permission: "subscriptions:pay_cheque", label: "Cheque" },
  { value: "Wallet", permission: "subscriptions:pay_wallet", label: "Wallet" },
  { value: "Other", permission: "subscriptions:pay_other", label: "Other" },
];

const METHOD_VALUES = VOUCHER_PAYMENT_METHODS.map((method) => method.value);

/**
 * Methods this user may select.
 * No method keys means every staff method, so Admin and Club Admin sessions
 * from before these permissions, and unrestricted dynamic roles, stay unchanged.
 * SuperAdmin follows the existing full-access rule.
 */
export function allowedVoucherPaymentMethods(user) {
  if (isPlatformSuperAdmin(user?.role)) return [...METHOD_VALUES];
  const permissions = Array.isArray(user?.permissions) ? user.permissions : [];
  const granted = VOUCHER_PAYMENT_METHODS.filter((method) =>
    permissions.includes(method.permission)
  );
  if (!granted.length) return [...METHOD_VALUES];
  return granted.map((method) => method.value);
}

/** Cash when it is allowed; otherwise the first allowed method. */
export function defaultVoucherPaymentMethod(allowed) {
  const methods = Array.isArray(allowed) ? allowed : [];
  if (methods.includes("Cash")) return "Cash";
  return methods[0] || null;
}
